// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"ed5b5df968f93590b1a7","883":"d137d63a1ad264261ca5"}[chunkId] + ".js";
};